export enum DateOrder {
    Increasing,
    Decreasing
}